<template>
  <section class="services-area section-space--pb_90" id="service">
    <div class="container">

      <div class="text-center mb-5">
        <h2 class="section-title">Nuestros Servicios</h2>
        <p class="section-subtitle">
          Soluciones tecnológicas diseñadas para impulsar y transformar tu negocio.
        </p>
      </div>

      <div class="row">

        <div v-for="service in services" :key="service.title" class="col-lg-4 col-md-6 mb-4">
          <div class="service-card wow move-up">

            <div class="icon-wrapper" aria-hidden="true">
              <i :class="service.icon"></i>
            </div>

            <h5 class="service-title">{{ service.title }}</h5>
            <p class="service-desc">{{ service.desc }}</p>

          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesLeonix',
  data() {
    return {
      services: [
        {
          title: 'Desarrollo de Software a la Medida',
          icon: 'fal fa-laptop-code',
          desc:
            'Construimos software potente, escalable y personalizado para resolver necesidades específicas de tu negocio.',
        },
        {
          title: 'Aplicaciones Móviles',
          icon: 'fal fa-mobile-android',
          desc:
            'Desarrollamos apps nativas y multiplataforma para Android y iOS con alto rendimiento y gran experiencia de usuario.',
        },
        {
          title: 'Aplicaciones Web',
          icon: 'fal fa-browser',
          desc:
            'Creamos plataformas web modernas, seguras y optimizadas para operar procesos y ofrecer servicios digitales.',
        },
        {
          title: 'Consultoría Tecnológica',
          icon: 'fal fa-lightbulb-on',
          desc:
            'Acompañamos a tu empresa en la definición, diseño y planificación de proyectos tecnológicos y productos digitales.',
        },
        {
          title: 'UX/UI y Diseño de Producto',
          icon: 'fal fa-pencil-paintbrush',
          desc:
            'Diseñamos interfaces intuitivas y experiencias digitales centradas en el usuario para maximizar resultados.',
        },
        {
          title: 'Automatización de Procesos',
          icon: 'fal fa-robot',
          desc:
            'Implementamos automatización inteligente para optimizar operaciones, reducir costos y mejorar eficiencia.',
        },
        {
          title: 'Business Intelligence (BI)',
          icon: 'fal fa-chart-line',
          desc:
            'Transformamos datos en decisiones con dashboards, análisis avanzado y herramientas de inteligencia empresarial.',
        },
        {
          title: 'Integración de Sistemas',
          icon: 'fal fa-plug',
          desc:
            'Conectamos tus sistemas, aplicaciones y servicios para lograr una operación fluida y completamente integrada.',
        },
        {
          title: 'Innovación Tecnológica',
          icon: 'fal fa-rocket-launch',
          desc:
            'Desarrollamos prototipos, soluciones de IA básica y modernización digital para acelerar tu evolución tecnológica.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #1d1d1f;
}

.section-subtitle {
  font-size: 16px;
  color: #555;
}

.service-card {
  background: #ffffff;
  padding: 28px;
  border-radius: 16px;
  transition: all 0.25s ease;
  height: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.service-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.icon-wrapper {
  font-size: 40px;
  color: #c6a675;
  margin-bottom: 16px;
}

.service-title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
}

.service-desc {
  color: #444;
  font-size: 15px;
  line-height: 1.4;
}
</style>
